import React, { useState } from "react";
import AddProviderForm from "./components/AddProviderForm";

function AddProvider() {
  const initialFormValue = {
    type: "payin",
    mode: "",
    providerPayinComm: "0.0",
    providerPayoutComm: "0.0",
    providerName: "",
    payinMinPerTxn: "0.0",
    payinMaxPerTxn: "0.0",
    payoutMinPerTxn: "0.0",
    payoutMaxPerTxn: "0.0",
    totalPayinLimit: "0.0",
    totalPayoutLimit: "0.0",
    isActive: false,
    currentPayinAmount: "0.0",
    currentPayoutAmount: "0.0",
    dailyPayinAmount: 0.0,
    runningWalletAmount: 0.0,
    startTime: "05:00",
    endTime: "23:59",
    minLength: "",
    maxLength: "",
    fallbackProviderId: "",
  };
  const [formData, setFormData] = useState(initialFormValue);
  // const FIXED_DATE = "2025-01-01";

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    let updatedValue = value;

    // if (name === "startTime" || name === "endTime") {
    //   updatedValue = `${FIXED_DATE}T${value}`; // merge with static date
    // }

    if (name === "isActive") {
      updatedValue = value === "true";
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  return (
    <>
      <h1 style={{ marginBottom: "20px" }}>Add Provider</h1>
      <AddProviderForm
        formData={formData}
        setFormData={setFormData}
        handleInputChange={handleInputChange}
        initialFormValue={initialFormValue}
      ></AddProviderForm>
    </>
  );
}

export default AddProvider;
